import React from 'react';
import { Provider } from 'react-redux';
import { useParams, useSearchParams } from 'react-router-dom';
import CanvasSA from './CanvasSA';
import EditorSA from './EditorSA';
import { generateStore } from './../../redux/store';
import Canvas from '../canvas/Canvas';
import theme from '../../utils/ChakraTheme';
import { ChakraProvider } from '@chakra-ui/react';
import GoogleFontLoaderSA from './GoogleFontLoaderSA';

const StoreWrapper = ({ userInfo, sharedRedux }) => {
	const { viewId } = useParams();
	const [searchParams] = useSearchParams();
	const isCanvas = searchParams.get('isCanvas');
	const store = React.useMemo(() => generateStore(viewId), [viewId]);

	if (!sharedRedux)
		return (
			<ChakraProvider theme={theme} resetCSS={false}>
				<Provider store={store}>
					<Canvas userInfo={userInfo} />
				</Provider>
			</ChakraProvider>
		);

	return (
		<Provider store={store}>
			{isCanvas ? (
				<>
					<GoogleFontLoaderSA viewId={viewId} />
					<CanvasSA userInfo={userInfo} />
				</>
			) : (
				<ChakraProvider theme={theme} resetCSS={false}>
					<EditorSA userInfo={userInfo} />
				</ChakraProvider>
			)}
		</Provider>
	);
};

export default StoreWrapper;
